import React, { useContext, useMemo } from 'react';
import { Line } from 'react-chartjs-2';
import moment from 'moment'

import ProfileContext from '../../context/profile-context';
import useStyles from '../../styles/components/profile/styleProfile'

const GrowthStudentChart = () => {
    const classes = useStyles()
    const { profileContext } = useContext(ProfileContext)
    const colorTraitChart = ['#46AA42', '#DA291C', '#23201F', 'blue',
        '#FF6633', '#FFB399', '#FF33FF', '#FFFF99', '#00B3E6',
        '#E6B333', '#3366E6', '#999966', '#99FF99', '#B34D4D',
        '#80B300', '#809900', '#E6B3B3', '#6680B3', '#66991A',
    ];

    const options = {
        maintainAspectRatio: false,
        title: {
            display: true,
            position: 'top',
            text: 'Trait Group Growth',
            fontSize: screen.width < 500 ? 14 : 18,
        },
        legend: {
            display: true,
            position: 'top',
            labels: {
                padding: 20,
            }
        },
        plugins: [{
            beforeInit: function(chart, options) {
              chart.legend.afterFit = function() {
                this.height = this.height + 50;
              };
            }
          }],
        elements: {
            line: { tension: 0 },
        },
        scales: {
            xAxes: [{
                gridLines: { drawOnChartArea: true },
                offset: true,
                ticks: {
                    beginAtZero: true,
                    max: 100,
                },
                scaleLabel: {
                    display: true,
                    labelString: 'Date'
                },
            }],
            yAxes: [{
                gridLines: { drawOnChartArea: true },
                ticks: {
                    beginAtZero: true,
                    stepSize: 10,
                    max: 100
                },
                scaleLabel: {
                    display: true,
                    labelString: 'Percent (%)'
                }
            }]
        },
        tooltips: {
            mode: 'point',
            intersect: false,
            callbacks: {
                title: () => {
                    return ""
                },
                label: function (tooltipItem, data) {
                    var label = `${data.datasets[tooltipItem.datasetIndex].label}: ${tooltipItem.yLabel}%`;
                    return label
                },
                afterLabel: function (tooltipItem, data) {
                    const labelHover = data.datasets[tooltipItem.datasetIndex].label;
                    var label = ``;
                    data.traitGroupScoreHistorys.map(item => {
                        if (item.traitGroupName === labelHover && tooltipItem.label === moment(item.createdDate).format("DD-MM-YYYY")) {
                            label = item.title
                        }
                    })
                    return label
                }
            },
        },
    }

    const datasets = useMemo(() => {
        const id = profileContext.idTraitGroupItems

        let position = 0
        if (id !== 0) {
            for (const i in profileContext.traitGroupItems) {
                if (id === profileContext.traitGroupItems[i].traitGroupId) {
                    position = i
                }
            }
        }

        return {
            labels: profileContext.dataGrowthChart.date,
            datasets: profileContext.dataGrowthChart.percentByTraitGroups.map((item, index) => {
                let borderWidth
                let pointRadius
                let pointHoverRadius
                if(screen.width < 500) {
                    borderWidth = 1.5
                    pointRadius = 1.5
                    pointHoverRadius = 2.5
                } else {
                    borderWidth = 3
                    pointRadius = 3
                    pointHoverRadius = 4
                }
                return({
                data: item.percent,
                label: item.traitGroupName,
                borderWidth,
                pointRadius,
                pointHoverRadius,
                borderColor: id !== 0 ? colorTraitChart[position] : colorTraitChart[index],
                fill: false,
                backgroundColor: id !== 0 ? colorTraitChart[position] : colorTraitChart[index],
                fillText: id !== 0 ? colorTraitChart[position] : colorTraitChart[index],
                showLine: true,
            })}),
            traitGroupScoreHistorys: profileContext.dataGrowthChart.traitGroupScoreHistorys
        }
    }, [profileContext.dataGrowthChart])

    return (
        <div className={classes.chart}>
            <Line data={datasets} options={options}/>
        </div>
    )
}
export { GrowthStudentChart as default };